// Iterates over all required inputs and add two focus callback to show/hide the mandatory explanation
var setupRequiredInputCallbacks = function() {
    // Fetch inputs
    var inputs = $('input,select').filter('[required]:visible');

    inputs.each(function( index ) {
        var input = $(this);

        // On focusout, if empty, show warning
        input.focusout(function (e){
            if(!input.val()){
                var warning = input.siblings('.mandatory-field-mention-js');
                warning.show();
            }
        });

        // On Focusin, hide warning
        input.focusin(function (e){
            var warning = input.siblings('.mandatory-field-mention-js');
            warning.hide();
        });
    });
};

var displayPassword = function() {
    $('.password-trigger').click(function (){
        var passwordInput = $(".password-container #password")
        var passwordInputType = passwordInput.attr('type')
        var type = passwordInputType === 'password' ? 'text' : 'password';

        passwordInput.attr('type', type);
        
        $('.no-view').toggle()
        $('.view').toggle()
    })
}


// --------------------
// Document ready
// --------------------
$(document).ready(function() {
    setupRequiredInputCallbacks();
    displayPassword();
});
